import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  style: {"font-size":"30px","margin-bottom":"8px"},
  class: "col-12 text-center"
}, " Ожидание ответа от банка... ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  style: {"font-size":"15px","margin-bottom":"20px"},
  class: "col-12 text-center"
}, " Не закрывайте страницу! ", -1)
const _hoisted_3 = {
  key: 0,
  class: "col-12 row justify-center q-mb-md"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_spinner_clock = _resolveComponent("q-spinner-clock")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _ctx.waitPayment,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.waitPayment) = $event)),
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { style: {"width":"500px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "row align-center justify-center items-center" }, {
            default: _withCtx(() => [
              _hoisted_1,
              _hoisted_2,
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_ctx.redirectUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_q_btn, {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.redirect())),
                          size: "sm",
                          rounded: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Перейти на страницу банка")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_q_spinner_clock, {
                color: "primary",
                size: "60px"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { class: "row justify-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancelPayment())),
                size: "sm",
                flat: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Отменить оплату")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}